import React from 'react';
import { useReportStore } from '../../../../store/reportStore';
import { TabId } from '../../../../store/reportStore';

export const ReportTabs: React.FC = () => {
  const { setActiveTab } = useReportStore();

  const tabs = [
    { id: 'maths' as TabId, label: 'Maths Report', color: '#4558C8' },
    { id: 'english' as TabId, label: 'English Report', color: '#DFF37D' },
    { id: 'other' as TabId, label: 'Other Games', color: '#E8D1FF' }
  ];

  return (
    <div className="flex gap-6 justify-between w-full mt-8">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`
            flex-1 h-[114px] rounded-[500px] relative overflow-hidden 
            transition-all duration-300 hover:opacity-90 
            max-sm:h-[83px] cursor-pointer
          `}
          style={{ backgroundColor: tab.color }}
        >
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-[2.1rem] font-[600] tracking-[-0.05em] text-white text-center">
              {tab.label}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
};